// extracted by mini-css-extract-plugin
module.exports = {"avatar":"PoolAvatar_avatar__2FEAe","avatarToken":"PoolAvatar_avatarToken__w0TdO"};